var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("page-outline", {
    attrs: {
      title: _vm.$t("Webheader.configuration_list_" + _vm.entitiesType),
      "show-filter": true,
      "show-refresh": true,
      "show-extract": _vm.flagCACP && _vm.messageRoutingIn.length > 0,
      "filter-expanded": _vm.displayFilter,
      "refresh-disabled": _vm.activateSpinner,
    },
    on: {
      "toggle-filter": _vm.toggleFilter,
      refresh: _vm.onRefresh,
      extract: _vm.extractCSV,
    },
    scopedSlots: _vm._u([
      {
        key: "filterContent",
        fn: function () {
          return [
            _c("app-panel", {
              attrs: {
                filters: _vm.filterConfig,
                searchAriaLabel:
                  _vm.$t("common.srch") +
                  " " +
                  _vm.$t("Webheader.configuration_list_" + _vm.entitiesType),
              },
              on: {
                "filter-changed": _vm.onFilterChanged,
                "clear-filters": _vm.clearFilterFields,
                "apply-filters": _vm.onRefresh,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "pageContent",
        fn: function () {
          return [
            _c(
              "b-container",
              { staticClass: "listPage", attrs: { fluid: "" } },
              [
                _c(
                  "b-row",
                  { staticClass: "justify-content-start" },
                  [
                    _vm.canGetEntityGroup() && _vm.entitiesType == "requester"
                      ? _c(
                          "b-col",
                          {
                            staticClass: "my-2",
                            attrs: { cols: "4", lg: "3", xl: "3" },
                          },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.$t(
                                  "common.routing.consult_list_entity_group"
                                ),
                                variant: "primary",
                                block: true,
                                "custom-class":
                                  "mr-3 justify-item-end responsive-button",
                              },
                              on: { click: _vm.getEntityGroup },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canAddMessageRouting && !_vm.activateSpinner && _vm.demo
                      ? _c(
                          "b-col",
                          {
                            staticClass: "my-2",
                            attrs: { cols: "4", lg: "3", xl: "3" },
                          },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.getAddButtonText(),
                                icon: "fa-light fa-plus",
                                variant: "primary",
                                block: true,
                                "custom-class":
                                  "mr-3 justify-item-end responsive-button",
                              },
                              on: { click: _vm.addMessageRouting },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canViewConnector() &&
                    (_vm.entitiesType == "rvm" ||
                      _vm.entitiesType == "requester")
                      ? _c(
                          "b-col",
                          {
                            staticClass: "my-2",
                            attrs: { cols: "4", lg: "3", xl: "3" },
                          },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.$t("common.routing.receiver"),
                                variant: "primary",
                                block: true,
                                "custom-class":
                                  "mr-3 justify-item-end responsive-button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getConfiguration("requester")
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canViewConnector() &&
                    (_vm.entitiesType == "rvm" ||
                      _vm.entitiesType == "responder")
                      ? _c(
                          "b-col",
                          {
                            staticClass: "my-2",
                            attrs: { cols: "4", lg: "3", xl: "3" },
                          },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.$t("common.routing.sender"),
                                variant: "primary",
                                block: true,
                                "custom-class":
                                  "mr-3 justify-item-end responsive-button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getConfiguration("responder")
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.entitiesType != "decentralised"
                      ? _c(
                          "b-col",
                          {
                            staticClass: "my-2",
                            attrs: { cols: "4", lg: "3", xl: "3" },
                          },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.$t(
                                  "common.routing.import_referentiel"
                                ),
                                icon: "fa-light fa-plus",
                                variant: "primary",
                                block: true,
                                disabled: true,
                                "custom-class":
                                  "justify-item-end responsive-button",
                              },
                              on: { click: _vm.addImportReferentiel },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canViewConnector() &&
                    _vm.entitiesType == "decentralised"
                      ? _c(
                          "b-col",
                          {
                            staticClass: "my-2",
                            attrs: { cols: "3", lg: "2", xl: "2" },
                          },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.$t(
                                  "common.routing.update_connector_stet"
                                ),
                                variant: "primary",
                                block: true,
                                "custom-class":
                                  "mr-3 justify-item-end responsive-button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getConfigurationS3("2", "1")
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canViewConnector() &&
                    _vm.entitiesType == "decentralised"
                      ? _c(
                          "b-col",
                          {
                            staticClass: "my-2",
                            attrs: { cols: "3", lg: "2", xl: "2" },
                          },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.$t(
                                  "common.routing.update_connector_entity"
                                ),
                                variant: "primary",
                                block: true,
                                "custom-class":
                                  "mr-3 justify-item-end responsive-button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getConfigurationS3("2", "2")
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canViewConnector() &&
                    _vm.entitiesType == "decentralised"
                      ? _c(
                          "b-col",
                          {
                            staticClass: "my-2",
                            attrs: { cols: "3", lg: "2", xl: "2" },
                          },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.$t(
                                  "common.routing.update_connector_cacp"
                                ),
                                variant: "primary",
                                block: true,
                                "custom-class":
                                  "mr-3 justify-item-end responsive-button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getConfigurationS3("3", "2")
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canViewConnector() &&
                    _vm.entitiesType == "decentralised"
                      ? _c(
                          "b-col",
                          {
                            staticClass: "my-2",
                            attrs: { cols: "3", lg: "2", xl: "2" },
                          },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.$t(
                                  "common.routing.update_connector_notification"
                                ),
                                variant: "primary",
                                block: true,
                                "custom-class":
                                  "mr-3 justify-item-end responsive-button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getConfigurationS3(
                                    "3",
                                    "2",
                                    "WEBSERVICE"
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-tabs",
                  { attrs: { "nav-class": "d-none" } },
                  [
                    _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("common.routing.in") } },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _vm.activateSpinner
                                  ? _c("spinner")
                                  : _c(
                                      "div",
                                      [
                                        _vm.messageRoutingIn.length
                                          ? _c("b-table", {
                                              staticClass: "mt-3 table-striped",
                                              attrs: {
                                                hover: "",
                                                relative: "",
                                                responsive: "",
                                                items: _vm.messageRoutingIn,
                                                fields: _vm.fields,
                                                selectable: "",
                                                "select-mode": "single",
                                              },
                                              on: {
                                                "row-selected": _vm.seeDetails,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "cell(RoutingType)",
                                                    fn: function (data) {
                                                      return [
                                                        data.item.MessageType ==
                                                        0
                                                          ? _c("span", [
                                                              _vm._v("DDV"),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        data.item.MessageType ==
                                                        1
                                                          ? _c("span", [
                                                              _vm._v("DDD"),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        data.item.MessageType ==
                                                        2
                                                          ? _c("span", [
                                                              _vm._v("DMA"),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        data.item.MessageType ==
                                                        3
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "DMA_CACP"
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(ConfigType)",
                                                    fn: function (data) {
                                                      return [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                data.item
                                                                  .ConfigType ===
                                                                  "NULL"
                                                                  ? data.item
                                                                      .ConfigType
                                                                  : data.item
                                                                      .ConfigType ===
                                                                    data.item
                                                                      .ConfigType
                                                                  ? data.item
                                                                      .ConfigType
                                                                  : data.item
                                                                      .ConfigType +
                                                                    " / " +
                                                                    data.item
                                                                      .ConfigType
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                  _vm.entitiesType == "rvm" ||
                                                  _vm.entitiesType ==
                                                    "requester"
                                                    ? {
                                                        key: "cell(ConfigIn)",
                                                        fn: function (data) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                "\n                   " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .NameConfigInput ==
                                                                      ""
                                                                      ? "-"
                                                                      : data
                                                                          .item
                                                                          .NameConfigInput
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      }
                                                    : null,
                                                  _vm.entitiesType == "rvm" ||
                                                  _vm.entitiesType ==
                                                    "responder" ||
                                                  _vm.entitiesType ==
                                                    "decentralised"
                                                    ? {
                                                        key: "cell(ConfigOut)",
                                                        fn: function (data) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                "\n                   " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .NameConfigOutput ==
                                                                      ""
                                                                      ? "-"
                                                                      : data
                                                                          .item
                                                                          .NameConfigOutput
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      }
                                                    : null,
                                                  {
                                                    key: "cell(Active)",
                                                    fn: function (data) {
                                                      return [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                   " +
                                                              _vm._s(
                                                                data.item
                                                                  .Active == "1"
                                                                  ? _vm.$t(
                                                                      "common.routing.active_1"
                                                                    )
                                                                  : _vm.$t(
                                                                      "common.routing.active_0"
                                                                    )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                  _vm.flagCACP &&
                                                  (_vm.entitiesType ===
                                                    "responder" ||
                                                    _vm.entitiesType ===
                                                      "decentralised" ||
                                                    _vm.entitiesType ===
                                                      "requester")
                                                    ? {
                                                        key: "cell(BillableBic)",
                                                        fn: function (data) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                "\n                   " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .BillableBic ==
                                                                      ""
                                                                      ? "-"
                                                                      : data
                                                                          .item
                                                                          .BillableBic
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      }
                                                    : null,
                                                ],
                                                null,
                                                true
                                              ),
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "noResult" },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.no_result"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mt-5" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("cm-pagination", {
                                  attrs: {
                                    maxResultsByPage:
                                      _vm.paginationObject.maxResults,
                                    firstIndex: _vm.paginationObject.firstIndex,
                                    nbResultsTotal:
                                      _vm.paginationObject.nbResultsTotal,
                                    refreshEvent: _vm.paginationObject.refresh,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }